export var CardSuit;
(function (CardSuit) {
    CardSuit["CLUBS"] = "clubs";
    CardSuit["SPADES"] = "spades";
    CardSuit["HEARTS"] = "hearts";
    CardSuit["DIAMONDS"] = "diamonds";
})(CardSuit || (CardSuit = {}));
